/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:54:58
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-30 14:16:08
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\base\state.js
 */
import * as STATETYPES from '../stateTypes'
import { identityType } from '@/assets/js/dictionary'
import locals from '@/local'
const state = {
	[STATETYPES.RESEARCHRAUTHORITY]: [], // 研究权限
	[STATETYPES.IDENTITYTYPE]: locals.getIdentityType() || identityType[0].value // 角色类型
}
export default state